import React from 'react';
import { FJ181 } from '../../../services/j209Api';

interface DetailMemoProps {
  detail: Partial<FJ181> | undefined;
  isEditing: boolean;
  onUpdate: (key: keyof FJ181, value: FJ181[keyof FJ181]) => void;
}

const DetailMemo: React.FC<DetailMemoProps> = React.memo(({ detail, isEditing, onUpdate }) => {
  if (!detail) {
    return <div className="detail-memo-panel" style={{ color: '#999' }}>請選擇明細行</div>;
  }

  return (
    <div className="detail-memo-panel">
      <div className="memo-row">
        <label>產品名稱</label>
        <textarea
          value={detail.fj181_19 || ''}
          onChange={e => onUpdate('fj181_19', e.target.value)}
          readOnly={!isEditing}
          rows={2}
        />
      </div>
      <div className="memo-row">
        <label>產品規格</label>
        <textarea
          value={detail.fj181_20 || ''}
          onChange={e => onUpdate('fj181_20', e.target.value)}
          readOnly={!isEditing}
          rows={2}
        />
      </div>
      <div className="memo-row">
        <label>加工別</label>
        <textarea
          value={detail.fj181_21 || ''}
          onChange={e => onUpdate('fj181_21', e.target.value)}
          readOnly={!isEditing}
          rows={2}
        />
      </div>
      <div className="spec-grid">
        <label>幅寬</label>
        <input
          type="number"
          value={detail.fj181_22 ?? ''}
          onChange={e => onUpdate('fj181_22', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          style={{ width: 80 }}
          step="0.1"
        />
        <label>米平方重</label>
        <input
          type="number"
          value={detail.fj181_25 ?? ''}
          onChange={e => onUpdate('fj181_25', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          style={{ width: 80 }}
          step="0.1"
        />
        <label>針孔內</label>
        <input
          type="number"
          value={detail.fj181_23 ?? ''}
          onChange={e => onUpdate('fj181_23', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          style={{ width: 80 }}
          step="0.1"
        />
        <label>針孔外</label>
        <input
          type="number"
          value={detail.fj181_24 ?? ''}
          onChange={e => onUpdate('fj181_24', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          style={{ width: 80 }}
          step="0.1"
        />
        <label>碼重</label>
        <input
          type="number"
          value={detail.fj181_17 ?? ''}
          onChange={e => onUpdate('fj181_17', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          style={{ width: 80 }}
        />
      </div>
    </div>
  );
});

DetailMemo.displayName = 'DetailMemo';
export default DetailMemo;
